import React from 'react';
import {PropTypes} from 'prop-types';
import HrbTranslate from '../language/HrbTranslate';
import './CardWidget.scss';

const CardWidgetTextInput = (props) => (
    <div>
      <div className="hrb-card-widget-input-label">
        <HrbTranslate text={props.fieldLabel}/>
      </div>
      <input
          tabIndex="4"
          className="form-control hrb-card-widget-input"
          onChange={(e) => props.onChange(e)}
          onBlur={(e) => props.onBlur && props.onBlur(e)}
          type="text"
          maxLength={props.maxLength}
      />
    </div>
);

CardWidgetTextInput.propTypes = {
  fieldLabel: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  maxLength: PropTypes.string
};

export default CardWidgetTextInput